var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSharebutton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7856 22C11.6889 22 11.5907 21.9826 11.498 21.9456C11.1971 21.8264 10.9999 21.5353 10.9999 21.2111V14.1358C5.14259 14.4214 1.35322 17.8162 1.31393 17.8517C1.06409 18.0797 0.698742 18.1223 0.404109 17.9574C0.109476 17.7933 -0.0476612 17.4588 0.0128367 17.1259C0.0332646 17.0146 0.52589 14.3819 2.19548 11.7216C4.30559 8.35916 7.34318 6.48037 11.0163 6.25184C11 5.72917 10.9999 4.29603 10.9999 3.86053V0.789159C10.9999 0.464113 11.1979 0.172991 11.4996 0.0546492C11.8005 -0.0644818 12.1431 0.0152019 12.3638 0.254253L21.7921 10.5161C22.0702 10.8198 22.0694 11.2877 21.7889 11.5891L12.3607 21.7491C12.2091 21.9124 11.9993 22 11.7856 22Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharebutton);
export default __webpack_public_path__ + "static/media/sharebutton.a40693c2.svg";
export { ForwardRef as ReactComponent };